import React from 'react';
import {SelectField, TextField} from "../Field";
import {countries} from 'country-data-list';
import {useOperator} from "../../../../context/OperatorContext";

// Helpers ----

const countryOptions = countries
  .all
  .filter(country => !!country.alpha3)
  .map(country => ({
    id: country.name,
    name: country.name,
  }))

// Component ----

type AddressFieldSetProps = {
  name: string
  label?: string
}

function AddressFieldSet({name, label}: AddressFieldSetProps) {
  const {settings} = useOperator();

  return (
    <fieldset>
      {!!label &&
        <legend className="block text-sm font-medium leading-6 text-gray-900">
          {label}
        </legend>
      }

      <div className="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6 mt-2">

        {/* Line 1 */}
        <div className="sm:col-span-6 lg:col-span-2">
          <TextField
            name={`${name}.line1`}
            label="Line 1 *"
            autoComplete="off"
            maxLength={250}
          />
        </div>

        {/* Line 2 */}
        <div className="sm:col-span-6 lg:col-span-2">
          <TextField
            name={`${name}.line2`}
            label="Line 2"
            hint="Optional"
            autoComplete="off"
            maxLength={250}
          />
        </div>

        {/* Line 3 */}
        <div className="sm:col-span-6 lg:col-span-2">
          <TextField
            name={`${name}.line3`}
            label="Line 3"
            hint="Optional"
            autoComplete="off"
            maxLength={250}
          />
        </div>

        {/* Town/City */}
        <div className="sm:col-span-6 lg:col-span-2">
          <TextField
            name={`${name}.city`}
            label="Town / City *"
            autoComplete="off"
            maxLength={100}
          />
        </div>

        {/* Post Code */}
        <div className="sm:col-span-6 lg:col-span-2">
          <TextField
            name={`${name}.postcode`}
            label={settings?.localisation.locale === 'en-US'? "Zip Code *" : "Post Code *"}
            autoComplete="off"
            maxLength={20}
          />
        </div>

        {/* Country */}
        <div className="sm:col-span-6 lg:col-span-2">
          <SelectField
            name={`${name}.country`}
            label="Country *"
            options={countryOptions}
          />
        </div>
      </div>
    </fieldset>
  );
}

export default AddressFieldSet;